import { useQuery } from '@tanstack/react-query';

import { InternalService, getPropertyImagesByInternalService } from '~/services/AccommodationService';

const IMPORT_IMAGES_LIMIT = 75;

export const propertyImagesByInternalServiceQueryKeys = {
  all: ['accommodation', 'property-images-by-internal-service'] as const,
  details: () => [...propertyImagesByInternalServiceQueryKeys.all, 'detail'] as const,
  detail: (internalService: InternalService | undefined, internalServiceId: string | undefined) =>
    [...propertyImagesByInternalServiceQueryKeys.details(), internalService, internalServiceId] as const,
};

export function useGetPropertyImagesByInternalService({
  internalService,
  internalServiceId,
  enabled = true,
}: {
  internalService: InternalService | undefined;
  internalServiceId: string | undefined;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: propertyImagesByInternalServiceQueryKeys.detail(internalService, internalServiceId),
    queryFn: async ({ signal }) => {
      if (!internalService || !internalServiceId) {
        throw new Error('internalService and internalServiceId are required');
      }

      const response = await getPropertyImagesByInternalService({
        internalService,
        internalServiceId,
        limit: IMPORT_IMAGES_LIMIT,
        signal,
      });
      return response.result;
    },
    enabled: enabled && !!internalService && !!internalServiceId,
    retry: false,
  });
}
